import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { bhojanCategoryService } from "@project/services/admin/bhojan-category.service";
import type {
  BhojanCategory,
  BhojanCategoryPayload,
} from "@project/types/bhojan";

const fields: Field[] = [
  {
    name: "name",
    label: "Category Name",
    required: true,
    showInTable: true,
    placeholder: "Lunch",
  },
  {
    name: "cut_off",
    label: "Cut-off Time",
    type: "time",
    required: true,
    showInTable: true,
    help: "Last time a booking is accepted for this category (Asia/Kolkata).",
  },
  {
    name: "is_active",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

/** Normalize API/HTML time values to HH:MM for the time input. */
function toTimeInputValue(value: unknown): string {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  const raw = String(value).trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!match) {
    return "";
  }
  return `${match[1].padStart(2, "0")}:${match[2]}`;
}

function toPayload(payload: Record<string, unknown>): BhojanCategoryPayload {
  const cutOff = toTimeInputValue(payload.cut_off);
  return {
    name: String(payload.name ?? "").trim(),
    cut_off: cutOff || undefined,
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function Page() {
  return (
    <AdminShell
      title="Bhojan Categories"
      subtitle="Manage meal categories used for Bhojanshala packages"
    >
      <ApiResourceTable<BhojanCategory>
        title="Category"
        labelField="name"
        fields={fields}
        searchFields={["name"]}
        defaultValues={{ is_active: true, cut_off: "11:00" }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        csvFileName="bhojan-categories"
        mapRecordToForm={record => ({
          ...record,
          cut_off: toTimeInputValue(record.cut_off),
        })}
        list={query => bhojanCategoryService.listPage(query)}
        create={payload => bhojanCategoryService.create(toPayload(payload))}
        update={(id, payload) =>
          bhojanCategoryService.update(id, toPayload(payload))
        }
        remove={id => bhojanCategoryService.delete(id)}
      />
    </AdminShell>
  );
}
